import { destroy, mutate, query, update, uploadFile } from "../../defaults/fetch";
import { useState, useEffect } from "react";

// Get all store departments
export const getStoreDepartments = async (storeId) => {
  const qs = {
    store: storeId
  };
  const url = `inventory/departments/`;
  const { data } = await query(url, qs);
  return data;
}

export const useGetAllStoreDepartments = (storeId, flag) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAllDepartments = async () => {
      if (!storeId) return;

      const qs = {
        store: storeId
      };
      setLoading(true);
      const url = `inventory/departments`;
      const { data } = await query(url, qs);
      setLoading(false);
      setDepartments(data);
    }
    getAllDepartments();
  }, [storeId, flag])

  return { loading, departments };
}

export const useCreateStoreDepartment = () => {
  const createDepartment = async (body) => {
    const url = `inventory/departments`;
    const { message } = await mutate(url, true, body);
    return message;
  }
  return createDepartment;
}

export const useUpdateStoreDepartment = () => {
  const updateDepartment = async (id, body) => {
    const url = `inventory/departments/${id}`;
    const { message } = await update(url, body);
    return message;
  }
  return updateDepartment;
}

export const useDeleteStoreDepartment = () => {
  const deleteDepartment = async (id) => {
    const url = `inventory/departments/${id}`;
    const { message } = await destroy(url);
    return message;
  }
  return deleteDepartment;
}
